import {Box, alpha} from '@mui/material';
import React from 'react';

import Timeline from './timeline.jsx';

const TimelineContainer = () => {
  return (
    <Box
      sx={theme => ({
        display: 'flex',
        alignItems: 'center',
        px: 1.5,
        background: `linear-gradient(${alpha(theme.colorSchemes.dark.palette.grey[900], 0)}, ${alpha(
          theme.colorSchemes.dark.palette.grey[900],
          0.95
        )})`,
      })}
    >
      <Timeline />
    </Box>
  );
};

export default TimelineContainer;
